import { useContext } from "react";
import { useSelector } from "react-redux";
import { form } from "../schemas/form";
import FormField from "layouts/Flow Designer/components/FormField";
import OptionLabel from "./OptionLabel";
import StyledDivider from "./StyledDivider";
import { FormFieldsContext } from "layouts/Flow Designer/context";

const AllowedOrigins = ({ allowEditWorkflow }) => {
  const { allowedOrigins } = form.formField;
  const formRef = useContext(FormFieldsContext);
  const { currentSavedFlow } = useSelector((store) => store?.designer?.flows);
  const isFlowActive = currentSavedFlow?.shared_status === "active";

  return (
    <>
      <OptionLabel label={allowedOrigins.label} name={allowedOrigins.name} allowEditWorkflow={allowEditWorkflow}/>
      <FormField
        type={allowedOrigins.type}
        label={""}
        name={allowedOrigins.name}
        value={formRef?.values.allowedOrigins}
        disabled={isFlowActive || !allowEditWorkflow}
      />
      <StyledDivider />
    </>
  );
};

export default AllowedOrigins;
